import React from "react"

export function SectionTitle({ title }: { title: string }) {
  return (
    <div style={{ marginBottom: "5px" }}>
      <h2>{title}</h2>
    </div>
  )
}
